/** @namespace breakpoints */
export default {
  xs: 600,
  md: 750,
  lg: 960,
  xl: 1200
};
